import React, { lazy, Suspense, ComponentType, FC } from 'react'
import reactifyWc from 'reactify-wc'

type ManifestEntry = { file: string; isEntry?: boolean }
type Manifest = Record<string, ManifestEntry>

const Empty: FC = () => null

export function registerWC<P extends object>(
  tag: string,
  baseUrl: string,
): FC<P> {
  const url = baseUrl.replace(/\/+$/, '')

  const Lazy = lazy(async () => {
    try {
      const res = await fetch(`${url}/.vite/manifest.json`)
      if (!res.ok) throw new Error(`manifest ${res.status} at ${url}`)
      const manifest: Manifest = await res.json()
      const entry = Object.values(manifest).find((m) => m.isEntry)
      if (!entry) throw new Error(`no entry at ${url}`)
      await import(
        /* webpackIgnore: true */ /* @vite-ignore */ `${url}/${entry.file}`
      )
      return { default: reactifyWc(tag) as ComponentType<P> }
    } catch (err) {
      console.error(`[registerWC] ${tag} load failed`, err)
      return { default: Empty as ComponentType<P> }
    }
  })

  const WC: FC<P> = (props) => (
    <Suspense fallback={null}>
      <Lazy {...(props as any)} />
    </Suspense>
  )
  return WC
}
